module.exports = __webpack_public_path__ + "static/img/promotion2.bbff6e63.png";